import { Link } from "react-router-dom";
import MediaCard from "@/components/feature/MediaCard";
import type { Media } from "@/mocks/media";

interface MediaGridProps {
  items: Media[];
  onReset?: () => void;
  emptyTitle?: string;
  emptyDesc?: string;
  loading?: boolean;
}

export default function MediaGrid({
  items,
  onReset,
  emptyTitle = "暂无匹配内容",
  emptyDesc = "换个筛选条件试试，或者看看其他频道的作品。",
  loading = false,
}: MediaGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="rounded-lg border border-background-200 overflow-hidden animate-pulse">
            <div className="w-full aspect-[6/8.4] bg-background-200"></div>
            <div className="p-3 space-y-2">
              <div className="h-3 w-3/4 rounded bg-background-200"></div>
              <div className="h-2.5 w-1/2 rounded bg-background-200"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-background-300 bg-background-50 py-16 px-6 text-center">
        <span className="w-14 h-14 mx-auto rounded-full bg-background-100 flex items-center justify-center">
          <i className="ri-search-eye-line text-2xl text-foreground-400"></i>
        </span>
        <h3 className="mt-4 font-heading text-base font-semibold text-foreground-900">{emptyTitle}</h3>
        <p className="mt-1.5 text-sm text-foreground-500">{emptyDesc}</p>
        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
          {onReset && (
            <button
              type="button"
              onClick={onReset}
              className="h-9 px-4 inline-flex items-center rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-refresh-line mr-1.5"></i>
              重置筛选
            </button>
          )}
          <Link
            to="/search"
            className="h-9 px-4 inline-flex items-center rounded-md border border-background-300 text-foreground-700 text-sm hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            去搜索
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
      {items.map((item) => (
        <MediaCard key={item.id} media={item} />
      ))}
    </div>
  );
}